import { ActionTypes } from "../constants/action-types";

export const setViditelnost = (viditelnost) => {
    return {
        type: ActionTypes.SET_VIDITELNOST,
        payload: viditelnost
    };
};
export const setPouziti = (pouziti) => {
    return {
        type: ActionTypes.SET_POUZITI,
        payload: pouziti
    };
};
export const setKlasifikace = (klasifikace) => {
    return {
        type: ActionTypes.SET_KLASIFIKACE,
        payload: klasifikace
    };
};
export const setRodinyPovrchu = (rodinyPovrchu) => {
    return {
        type: ActionTypes.SET_RODINYPOVRCHU,
        payload: rodinyPovrchu
    };
};
export const setRodinyVybaveni = (rodinyVybaveni) => {
    return {
        type: ActionTypes.SET_RODINYVYBAVENI,
        payload: rodinyVybaveni
    };
};